import gql from 'graphql-tag';

export const supplier = gql`
subscription getSupplier($id: uuid!){
    dental_suppliers_by_pk(id:$id){
    id
    email
    name
    business_name
    phone
    type
    subsciption_plan_id
    present_subscription_id
    logo
    community_id
    community_status

  }
}
`;


export const getClient = gql`
query getClient($id: uuid!){
    clients_by_pk(id:$id){
    id
    payload
    name
    email
    phone
    


  }
}
`;



export const practice = gql`
query getPractice($id: uuid!){
    dental_practices_by_pk(id:$id){
        id
        email
        name
        phone
        type
        business_name
        profile_completed
        subsciption_plan_id
        present_subscription_id
        logo

  }
}
`;


export const professional = gql`
query getProfessional($id: uuid!){
    dental_professionals_by_pk(id:$id){
        id
        email
        name
        phone
        first_name
        last_name
        type
        subsciption_plan_id
        present_subscription_id
  }
}
`;

export const professionalDeaData = gql`
subscription getProfessional($id: uuid!){
    dental_professionals_by_pk(id:$id){
        id
        email
        name
        phone
        first_name
        last_name
        profile_image
        type
        profile_completed
        
  }
}
`;


export const practiceDisplay = gql`
subscription practiceDisplay($id: uuid!){
    dental_practices_by_pk(id:$id){
        abn_number
        address
        alt_email
        alt_phone
        bank_details
        blocked_at
        blocked_reason
        business_email
        business_name
        business_phone
        contact_person_first_name
        contact_person_gender
        contact_person_last_name
        contact_person_middle_name
        contact_person_profile_image
        created_at
        credits
        defaultAddress
        directory_category_id
        directory_column_other_name
        driving_licence
        email
        email_verification_expiry_at
        email_verification_key
        email_verification_required
        email_verified
        fax_number
        first_name
        id
        last_name
        logo
        middle_name
        name
        passcode
        password
        password_reset_expiry_at
        password_reset_key
        password_reset_required
        payment_completed
        phone
        phone_verification_expiry_at
        phone_verification_key
        phone_verification_required
        phone_verified
        present_subscription_id
        pro_details_abn_acn_number
        pro_details_aphra_registration_number
        pro_details_driving_license_image
        pro_details_other_attachments
        pro_details_provider_number
        profession_type
        profile_completed
        profile_image
        second_hand
        secondary_contact
        sell_products
        status
        subsciption_plan_id
        tga_number
        timings
        type
          directories{
        id
        name
        email
        phone
        profile_image
        address
        profession_type
        }
  }
}
`;


export const supplierDisplay = gql`
subscription supplierDisplay($id: uuid!){
    dental_suppliers_by_pk(id:$id){
    id
    email
    name
    logo
    phone
    address
    pro_details_aphra_registration_number
    bank_details
    business_name
    abn_number
    business_email
    business_phone
    fax_number
    alt_email
    alt_phone
    profession_type
    tga_number
    second_hand
    sell_products
    first_name
    middle_name
    last_name
    type
    secondary_contact
     directories{
        id
        name
        email
        phone
        profile_image
        address
        profession_type
        }
  }
}
`;


export const professionalDisplay = gql`
subscription professionalDisplay($id: uuid!){
    dental_professionals_by_pk(id:$id){
        id
        email
        name
        phone
        first_name
        middle_name
        last_name
        second_hand
        alt_email
        alt_phone
        profession_type
        address
        pro_details_aphra_registration_number
        bank_details
        date_of_birth
        salutation
        driving_licence
        profile_image
        gender
        type
        clients{
         state
        postal_code

        }  
        directories{
        id
        name
        email
        phone
        profile_image
        address
        profession_type
        }
        

  }
}
`;



export const getAllUserSubscrptions = gql`
query getAllUserSubscrptions($id:uuid!){
  user_subscriptions(where:{
    _or:[{
      dental_supplier_id: {_eq: $id}
    },{
      dental_practice_id: {_eq: $id}
    },{
      dental_professional_id: {_eq: $id}
    }]
  }){
    id
    created_at
    expires_at
    total_amount
    subscription_plan_id
    dental_supplier_id
    dental_professional_id
    payment_intent
    dental_practice_id
    stripe_subscription_id
    subscription_plan{
      name
      tenure_in_days
      benefits
    }
  }
}
`;




// export const updateProfDetails = gql`mutation update_dental_professionals_by_pk(
//   $id: uuid!, 
//   $profObj: dental_professionals_set_input!
// ) {
//   update_dental_professionals_by_pk(
//     pk_columns: { id: $id }, 
//     _set: $profObj
//   ) {
//     id
//   }
// }
// `;
// export const updateProfDetails = gql`mutation update_dental_professionals_by_pk($id: uuid! ,$profObj: dental_professionals_set_input!){
//   update_dental_professionals_by_pk(pk_columns:{id: $id}, _set: $profObj){
//     id
//   }
// }`;

export const updateDirectoryDetails = gql`
  mutation update_directories_by_pk($id: uuid!, $dirObj: directories_set_input!) {
    update_directories_by_pk(pk_columns: { id: $id }, _set: $dirObj) {
      id
    }
  }
`;



export const updateSupplierDetails = gql`

mutation addSupplier($id: uuid!, $supplierObj: dental_suppliers_set_input!) {
  update_dental_suppliers(where:{id:{_eq: $id}},_set: $supplierObj) {
   affected_rows
    
  }
}

`;

export const updatePracticeDetails = gql`

mutation addPractice($id: uuid!, $practiceObj: dental_practices_set_input!) {
  update_dental_practices(where:{id:{_eq: $id}},_set: $practiceObj) {
   affected_rows
    
  }
}

`;


export const updateProfImage = gql`mutation update_dental_professionals_by_pk($id: uuid! ,$userImage: dental_professionals_set_input!){
  update_dental_professionals_by_pk(pk_columns:{id: $id}, _set: $userImage){
    id
  }
}`;

export const updateSupplierImage = gql`mutation update_dental_suppliers_by_pk($id: uuid! ,$userImage: dental_suppliers_set_input!){
  update_dental_suppliers_by_pk(pk_columns:{id: $id}, _set: $userImage){
    id
  }
}`;

export const updatePracticeImage = gql`mutation update_dental_practices_by_pk($id: uuid! ,$userImage: dental_practices_set_input!){
  update_dental_practices_by_pk(pk_columns:{id: $id}, _set: $userImage){
    id
  }
}`;


//  ADD Subscriber
export const addSubscriber = gql`
  mutation insert_dental_professionals($object: dental_professionals_insert_input!) {
    insert_dental_professionals_one(object: $object) {
      id
    }
  }
`;

//  UPDATE Subscriber
export const updateSubscriber = gql`
  mutation update_dental_professionals_by_pk(
    $id: uuid!, 
    $_set: dental_professionals_set_input!
  ) {
    update_dental_professionals_by_pk(
      pk_columns: {id: $id}, 
      _set: $_set
    ) {
      id
    }
  }
`;

//  UPDATE Professional Details
export const updateProfessionalDetails = gql`
  mutation update_dental_professionals_by_pk(
    $id: uuid!, 
    $_set: dental_professionals_set_input!
  ) {
    update_dental_professionals_by_pk(
      pk_columns: {id: $id}, 
      _set: $_set
    ) {
      id
    }
  }
`;

export const UPDATE_DENTAL_PROFESSIONAL = gql`
  mutation update_dental_professionals_by_pk(
    $id: uuid!, 
    $_set: dental_professionals_set_input!
  ) {
    update_dental_professionals_by_pk(
      pk_columns: { id: $id }, 
      _set: $_set
    ) {
      id
    }
  }
`;



// export const UPDATE_DENTAL_PROFESSIONAL_COMBINED = gql`
//   mutation update_dental_professionals_by_pk(
//     $id: uuid!,
//     $_set: dental_professionals_set_input!
//   ) {
//     update_dental_professionals_by_pk(
//       pk_columns: { id: $id },
//       _set: $_set
//     ) {
//       id
//     }
//   }
// `;


// export const UPDATE_DENTAL_PROFESSIONAL_COMBINED = gql`
//   mutation update_dental_professionals_by_pk(
//     $id: uuid!,
//     $_set: dental_professionals_set_input!
//   ) {
//     update_dental_professionals_by_pk(
//       pk_columns: { id: $id },
//       _set: $_set
//     ) {
//       id
//     }
//   }
// `;

export const updateProfDetails = gql`
  mutation update_dental_professionals_by_pk(
    $id: uuid!,
    $profObj: dental_professionals_set_input!
  ) {
    update_dental_professionals_by_pk(
      pk_columns: { id: $id },
      _set: $profObj
    ) {
      id
    }
  }
`;
export const UPDATE_DENTAL_PROFESSIONAL_COMBINED = gql`
  mutation update_dental_professionals_by_pk(
    $id: uuid!,
    $_set: dental_professionals_set_input!
  ) {
    update_dental_professionals_by_pk(
      pk_columns: { id: $id },
      _set: $_set
    ) {
      id
    }
  }
`;

export const UPDATE_PROF_NAME = gql`
  mutation update_dental_professionals_by_pk(
    $id: uuid!,
    $_set: dental_professionals_set_input!
  ) {
    update_dental_professionals_by_pk(
      pk_columns: { id: $id },
      _set: $_set
    ) {
      id
    }
  }
`;


export const GET_COMMUNITY_MEMBERS_BY_STATUS = gql`
  query GetCommunityMembersByStatus(
  $where: community_members_bool_exp!,
  $limit: Int!,
  $offset: Int!
) {
  community_members(
    where: $where,
    order_by: { created_at: desc },
    limit: $limit,
    offset: $offset
  ) {
    id
    first_name
    last_name
    membership_number
    status
    email
    phone
    supplier_id
    community_id
    register_link
    is_registered
  }
}
`;

export const GET_JOINED_COMMUNITIES = gql`
 query getJoinedCommunities($member_id: uuid!) {
  community_members(
      where: { 
        member_id: { _eq: $member_id }, 
        status: { _eq: "APPROVED" } 
      }
    ) {
    id
    community_id
    community_name
    supplier_id
    member_id
    status
  }
}
`;

export const GET_PARTNERSHIP_MEMBERS_BY_STATUS = gql`
  query GetPartnershipMembersByStatus(
    $where: partnership_members_bool_exp!,
    $limit: Int!,
    $offset: Int!
  ) {
    partnership_members(
      where: $where,
      order_by: { created_at: desc },
      limit: $limit,
      offset: $offset
    ) {
      id
      company_name
      contact_name
      email
      phone
      status
      is_registered
      community_id
      supplier_id
      register_link
    }
  }
`;

export const GET_SUPPLIER_COMMUNITY_OWNER = gql`
 query getSupplierCommunityOwner($dental_supplier_id: uuid!) {
  dental_suppliers(
      where: { id: { _eq: $dental_supplier_id } }
      limit: 1
    ) {
    id
    community_id
    community_status
    business_name
  }
}
`;

export const GET_DIRECTORY_BY_LOGIN_TYPE = gql`
  query getDirectory($where: directories_bool_exp!) {
    directories(where: $where) {
      id
      dental_supplier_id
      community_id
      partnership_link
      membership_link
      community_status
    }
  }
`;

export const UPDATE_CLIENT_MUTATION = gql`
mutation UpdateClient($id: uuid!, $changes: clients_set_input!) {
  update_clients_by_pk(pk_columns: {id: $id}, _set: $changes) {
    id
  }
}
`;

